<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <global-table
          :table-data="cro_assigned_task"
          :loading="loading"
          :per-page="10"
          :bordered="true"
          :table-detail="tableDetail"
          :hover="true"
          :striped="false"
          :fields="fields"
          :row-edit="taskMigrationForm"
          :redirect-detail="false"
          :show-add-button="true"
          :remove-button="true"
          :custom-button-detail="true"
          :refresh-logs="false"
          caption="<i class='fa fa-align-justify'></i> Pindah Tugas CRO (Khusus Konsumen Yang > 3 Minggu Tidak Order)"
          addButton="Tambah Pembagian Tugas CRO"
          @editForm="editForm"
          @resetForm="resetForm"
          @removeForm="removeForm"
        ></global-table>
      </b-col>
    </b-row>

    <b-modal
      ref="myModalRef"
      id="addModals"
      header-border-variant="no-border text-center"
      footer-border-variant="no-border"
      footer-bg-variant="light"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      size="lg"
    >
      <div slot="modal-header" class="text-center">
        <h3 class="text-center">
          Pindah Tugas CRO (Khusus Konsumen Yang > 3 Minggu Tidak Order)
        </h3>
      </div>

      <div v-if="loadingSubmit">
        <loading></loading>
      </div>

      <div v-if="!loadingSubmit">
        <b-form id="taskMigrationForm" validated novalidate>
          <b-row>
            <b-col sm="6">
              <b-form-group
                label-for="assigned_prev"
                label="Pindahkan Konsumen Dari Employee"
              >
                <model-select
                  id="assigned_prev"
                  :options="listEmployee"
                  v-model="$v.taskMigrationForm.assigned_prev.$model"
                  :isError="$v.taskMigrationForm.assigned_prev.$invalid"
                  placeholder="-- Harap pilih salah satu --"
                ></model-select>
                <div
                  v-if="taskMigrationForm.assigned_prev === null"
                  class="invalid-feedback-custom"
                >
                  Employee harus di isi.
                </div>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group
                label-for="assigned_to"
                label="Di Tugaskan Untuk Employee"
              >
                <model-select
                  id="assigned_to"
                  :options="listEmployee"
                  v-model="$v.taskMigrationForm.assigned_to.$model"
                  :isError="$v.taskMigrationForm.assigned_to.$invalid"
                  placeholder="-- Harap pilih salah satu --"
                ></model-select>
                <div
                  v-if="taskMigrationForm.assigned_to === null"
                  class="invalid-feedback-custom"
                >
                  Employee harus di isi.
                </div>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </div>

      <div slot="modal-footer" class="float-right">
        <div v-if="!loadingSubmit">
          <b-button type="button" size="sm" variant="danger" @click="cancelAdd">
            <i class="fa fa-undo"></i> Back </b-button
          >&nbsp;
          <b-button
            type="button"
            size="sm"
            variant="primary"
            @click="submitAdd"
            :disabled="$v.taskMigrationForm.$invalid"
          >
            <i class="fa fa-save"></i> Save
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "../../templates/Table.vue";
import interfaces from "@/templates/_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import * as moment from "moment";
import "moment/locale/id";
import { ModelSelect, MultiSelect } from "vue-search-select";
import custom_validation from "@/templates/_customValidation.js";
import loading from "@/templates/Loading.vue";

export default {
  name: "cro_task_migration",
  components: { globalTable, ModelSelect, MultiSelect, loading },
  props: {
    tableDetail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      cro_assigned_task: [],
      listEmployee: [],
      taskMigrationForm: interfaces.task_migration_cro,
      loading: true,
      loadingSubmit: false,
      isEdit: false,
      fields: [
        {
          key: "employee_name_prev",
          label: "Di handle Sebelumnya",
          sortable: true,
        },
        {
          key: "employee_name_now",
          label: "Di handle Sekarang",
          sortable: true,
        },
        { key: "total", label: "Total Handle Customer", sortable: true },
        { key: "action", class: "text-center width-150" },
      ],
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  validations() {
    if (this.isEdit === false) {
      return custom_validation.migrationTask.add;
    } else {
      return custom_validation.migrationTask.edit;
    }
  },
  methods: {
    init: function () {
      this.isEdit = false;
      this.loading = true;
      this.getData();
      this.getDropdown();
    },
    getData: function () {
      this.axios
        .get("web/cro/assigned_task/all/")
        .then((response) => {
          this.cro_assigned_task = response.data.data;
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    getDropdown: function () {
      this.axios
        .get("web/cro/assigned_task/list-employee/")
        .then((response) => {
          this.listEmployee = response.data.data;
        })
        .catch((error) => {})
        .finally(() => {});
    },
    cancelAdd: function () {
      this.$refs.myModalRef.hide();
    },
    editForm: function (editData) {
      this.isEdit = true;
      this.taskMigrationForm = editData;
    },
    resetForm: function () {
      this.isEdit = false;
      for (var a in interfaces.task_migration_cro) {
        interfaces.task_migration_cro[a] = null;
      }
      this.taskMigrationForm = interfaces.task_migration_cro;
    },
    removeForm: function(row) {
      this.resetForm();
      if (confirm("Apakah anda ingin menghapus pembagian tugas ini ?")) {
          this.loadingSubmit = true;
          this.axios
            .delete(
              "web/cro/assigned_task/remove/"+row.row_id+"/",
              this.taskMigrationForm
            )
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Hapus Penugasan",
                  message: response.data.message,
                });
                //this.$refs.myModalRef.hide();
              }
            })
            .catch((error) => {
              this.expired(error);
            })
            .finally(() => {
              this.loadingSubmit = false;
              this.init();
            });
        }
      console.log(row);
    },
    submitAdd: function (evt) {
      evt.preventDefault();
      if (this.isEdit) {
        if (confirm("Apakah anda ingin merubah pembagian tugas ini ?")) {
          this.loadingSubmit = true;
          this.axios
            .put(
              "web/cro/assigned_task/change-migration-task/",
              this.taskMigrationForm
            )
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Ubah Penugasan",
                  message: response.data.message,
                });
                this.$refs.myModalRef.hide();
                //this.$router.push({ path: "all/detail/" + response.data.id });
              }
            })
            .catch((error) => {
              this.expired(error);
            })
            .finally(() => {
              this.loadingSubmit = false;
              this.init();
            });
        }
      } else {
        if (confirm("Apakah anda ingin menambahkan pembagian tugas ini ?")) {
          if (
            this.taskMigrationForm.assigned_to ===
            this.taskMigrationForm.assigned_prev
          ) {
            alert(
              "Maaf Permintaan ini tidak dapat di proses, karena karyawannya sama."
            );
          } else {
            this.loadingSubmit = true;
            this.axios
              .post(
                "web/cro/assigned_task/migration-task/",
                this.taskMigrationForm
              )
              .then((response) => {
                if (response.data.status === 2000) {
                  this.showInfoNotification({
                    title: "Tambah Penugasan",
                    message: response.data.message,
                  });
                  this.$refs.myModalRef.hide();
                  //this.$router.push({ path: "all/detail/" + response.data.id });
                }
              })
              .catch((error) => {
                this.expired(error);
              })
              .finally(() => {
                this.loadingSubmit = false;
                this.init();
              });
          }
        }
      }
      //console.log(this.taskCoverageForm)
    },
    expired: function (error) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired",
        });
      } else {
        this.showErrorNotification({
          title: "Tambah Konsumen",
          message: error.response.data.message,
        });
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>